const filterButton = document.getElementById('small-filters');
const filterView = document.getElementById('filterview');
const toggledView = document.getElementById('toggle');
const closeFilter = document.getElementById('close');
const underlay = document.getElementById('underlay');
const submit = document.getElementById('submitclose');
export default () => {
    filterButton.addEventListener('click', () => {
        filterView.classList.toggle('up');
        toggledView.classList.toggle('hidden');
        underlay.classList.toggle('hidden');
    });
    closeFilter.addEventListener('click', () => {
        filterView.classList.toggle('up');
        toggledView.classList.toggle('hidden');
        underlay.classList.toggle('hidden');
    });
    underlay.addEventListener('click', () => {
        filterView.classList.toggle('up');
        toggledView.classList.toggle('hidden');
        underlay.classList.toggle('hidden');
    });
    submitclose.addEventListener('click', () => {
        filterView.classList.toggle('up');
        toggledView.classList.toggle('hidden');
        underlay.classList.toggle('hidden');
    });

    let timeoutValue ;
    //
    // window.addEventListener("resize", () => {
    //
    //     // clearTimeOut() resets the setTimeOut() timer
    //     // due to this the function in setTimeout() is
    //     // fired after we are done resizing
    //     clearTimeout(timeoutValue);
    //
    //     // setTimeout returns the numeric ID which is used by
    //     // clearTimeOut to reset the timer
    //     timeoutValue = setTimeout(window.location.reload(), 500);
    // });
}
